import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import ProfessionalForm  from "../../components/Forms/ProfessionalForm";
import { ProfessionalEntity } from "../../store/entities/state";
import { getChangingState, getChangingValue, isSubmittingNew } from "../../store/entities/selectors";
import { createEntity, entityCreatingCancel, updateChangingEntity } from "../../store/entities/actions";
import { createProfessionalAsync } from "../../ajax/requests";
import { ProfessionalFormDispatchProps, ProfessionalFormStateProps } from "../../components/Forms/ProfessionalForm/ProfessionalForm";

const mapStateToProps = (state: ApplicationState): ProfessionalFormStateProps => ({
    type: 'create',
    canEdit: true,
    data: getChangingValue(state, 'professionals') as ProfessionalEntity,
    hasChanged: getChangingState(state, 'professionals'),
    isSubmitting: isSubmittingNew(state, 'professionals'),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch): ProfessionalFormDispatchProps => ({
    onChange: (data: ProfessionalEntity) => dispatch(updateChangingEntity('professionals', data)),
    onCancel: () => dispatch(entityCreatingCancel('professionals')),
    onSave: (data: ProfessionalEntity) => dispatch(createEntity('professionals', data, c => createProfessionalAsync(c))),
});

export default connect<ProfessionalFormStateProps, ProfessionalFormDispatchProps, unknown, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ProfessionalForm as any);